import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const VehicleControlMileage = {
    allControlMileage: async () => axios.get(`${API_URL}/vehicle_controlmileage/allControlMileage`).then(({data}) => data.map(d => ({value: d.id, label: d.text}))).catch((err) => { throw err })
};

export default VehicleControlMileage;